// src/utils/fetchUserPermissions.js

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

console.log("Fetch User Permissions - API Base URL:", BASE_URL);

export const fetchUserPermissions = async () => {
  console.log("Fetch User Permissions - API Base URL:", BASE_URL);
  try {
    const response = await fetch(`${BASE_URL}/api/user-permissions`, {
      method: "GET",
      credentials: "include",
    });

    console.log("Permissions response status:", response);

    if (!response.ok) throw new Error("Failed to fetch permissions");

    const data = await response.json();
    console.log("Fetched permissions data:", data);

    return data.permissions;
  } catch (err) {
    console.error("Permission fetch failed:", err);
    return [];
  }
};